module.exports = __webpack_public_path__ + "img/china-section2-right.79d115f4.png";